<!-- 20/Oct/2018, Luis: Phase2, configuration for invoice list display in APP. -->
<template>
  <div class="animated fadeIn">
    <div class="form-row">
      <div class="form-group col-md-6">
        <b-alert :variant="alertVariant" dismissible :show="showDismissibleAlert"
                 @dismissed="showDismissibleAlert=false">
          {{ message }}
        </b-alert>
        <label for="invoiceFieldsCheckbox" class="col-form-label">Select Auto-load Invoice Fields to Display</label>
        <ul class="list-group" id="invoiceFieldsCheckbox">
          <li class="list-group-item" v-for="item in availableInvoiceFields" style="max-height:200px; overflow-y:auto">
            <input type="checkbox" :name="item.name" :value="item.value" v-model="invoiceFieldsToDisplay"/>
            <span>{{ item.name }}</span>
          </li>
        </ul>
        <br/>
        <button type="submit" class="btn btn-primary" @click="saveInvoiceFieldsToDisplay()">Save</button>
        <button type="submit" class="btn btn-primary" @click="resetInvoiceFieldsToDisplay()">Reset</button>
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Configuration',
    data () {
      return {}
    },
    created: function () {
      // initialise data from firestore DB
      this.$store.dispatch('configmod/initialiseConfiguration')
    },
    computed: {
      availableInvoiceFields: {
        get: function () {
          return this.$store.state.configmod.availableInvoiceFields
        }
      },
      invoiceFieldsToDisplay: {
        get: function () {
          return this.$store.state.configmod.invoiceFieldsToDisplay
        },
        set: function (newValues) {
          this.$store.commit('configmod/updateInvoiceFieldsToDisplay', newValues)
        }
      },
      alertVariant: {
        get: function () {
          return this.$store.state.configmod.alertVariant
        }
      },
      showDismissibleAlert: {
        get: function () {
          return this.$store.state.configmod.showDismissibleAlert
        },
        set: function (dismiss) {
          this.$store.commit('configmod/closeDismissibleAlert', dismiss)
        }
      },
      message: {
        get: function () {
          return this.$store.state.configmod.message
        }
      }
    },
    methods: {
      saveInvoiceFieldsToDisplay: function () {
        this.$store.dispatch('configmod/saveInvoiceFieldsToDisplay')
      },
      resetInvoiceFieldsToDisplay: function () {
        this.$store.dispatch('configmod/resetInvoiceFieldsToDisplay')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Configuration.vue